import { renderInDocument } from '@spotahome/soyuz/client';

import HomeCheckerContainer from './main';

renderInDocument(HomeCheckerContainer);
